import React, { useState } from 'react';
import { Users, AlertTriangle, BookOpen, Activity, ArrowRight, CheckCircle, X } from 'lucide-react';

export default function CoachHelpTour({ run, onFinish }) {
  const [currentStep, setCurrentStep] = useState(0);

  if (!run) return null;

  const steps = [
    {
      icon: <Users size={48} color="#f97316" />,
      title: 'Tu Centro de Mando',
      content: 'Bienvenido al panel central. Aquí puedes ver a todos tus atletas activos de un solo vistazo, ordenados por prioridad de atención según su estado de fatiga y recuperación.'
    },
    {
      icon: <AlertTriangle size={48} color="#ef4444" />,
      title: 'Triage Predictivo',
      content: 'Nuestro motor de Inteligencia Artificial analiza el HRV, sueño y carga (TSB) de tus atletas cada mañana. Te avisaremos con alertas visuales (rojo, naranja, verde) antes de que un atleta sufra sobreentrenamiento.'
    },
    {
      icon: <BookOpen size={48} color="#10b981" />,
      title: 'Librería y Asignación Rápida',
      content: 'Crea tus plantillas de entrenamiento favoritas en la Librería. Con un solo clic, podrás enviar estas sesiones directamente al calendario de tus atletas sin salir de la plataforma.'
    },
    {
      icon: <Activity size={48} color="#3b82f6" />,
      title: 'Panel Biométrico Profundo',
      content: 'Haz clic en cualquier atleta para abrir su ficha. Podrás ver en detalle sus curvas de estado de forma (PMC), evolución fisiológica e interactuar por chat directo con ellos.'
    }
  ];

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      onFinish();
    }
  };

  const step = steps[currentStep];

  return (
    <div style={{
      position: 'fixed',
      top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(0, 0, 0, 0.7)',
      backdropFilter: 'blur(8px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.3s ease-out'
    }}>
      <div style={{
        background: 'rgba(20, 25, 40, 0.95)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.05) inset',
        borderRadius: '24px',
        width: '90%',
        maxWidth: '500px',
        overflow: 'hidden',
        position: 'relative'
      }}>
        
        {/* Close Button */}
        <button 
          onClick={onFinish}
          style={{
            position: 'absolute', top: '16px', right: '16px',
            background: 'transparent', border: 'none',
            color: 'rgba(255,255,255,0.4)', cursor: 'pointer',
            padding: '8px', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            transition: 'all 0.2s'
          }}
          onMouseOver={e => { e.currentTarget.style.color = 'white'; e.currentTarget.style.background = 'rgba(255,255,255,0.1)'; }}
          onMouseOut={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.4)'; e.currentTarget.style.background = 'transparent'; }}
        >
          <X size={20} />
        </button>

        {/* Progress Dots */}
        <div style={{ display: 'flex', gap: '8px', padding: '24px 32px 0' }}>
          {steps.map((_, idx) => (
            <div key={idx} style={{
              height: '4px', flex: 1, borderRadius: '2px',
              background: idx === currentStep ? 'var(--strava-orange)' : 
                          idx < currentStep ? 'rgba(249, 115, 22, 0.3)' : 'rgba(255,255,255,0.1)',
              transition: 'all 0.3s'
            }} />
          ))}
        </div>

        {/* Content */}
        <div style={{ padding: '32px', textAlign: 'center' }}>
          <div style={{ 
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '96px', height: '96px', borderRadius: '48px',
            background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.05)',
            marginBottom: '24px'
          }}>
            {step.icon}
          </div>
          
          <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 16px 0' }}>{step.title}</h2>
          <p style={{ color: 'var(--text-secondary)', lineHeight: 1.6, fontSize: '1.05rem', margin: 0, minHeight: '80px' }}>
            {step.content}
          </p>
        </div>

        {/* Footer */}
        <div style={{ 
          padding: '24px 32px', background: 'rgba(0,0,0,0.2)', borderTop: '1px solid rgba(255,255,255,0.05)',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center'
        }}>
          <button 
            onClick={onFinish}
            style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer' }}
          >
            Saltar tour
          </button>
          
          <button 
            onClick={handleNext}
            style={{
              background: 'var(--strava-orange)', color: 'white',
              border: 'none', borderRadius: '12px',
              padding: '12px 24px', fontSize: '1rem', fontWeight: 700,
              display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(249, 115, 22, 0.3)'
            }}
          >
            {currentStep === steps.length - 1 ? (
              <>Comenzar <CheckCircle size={18} /></>
            ) : (
              <>Siguiente <ArrowRight size={18} /></>
            )}
          </button>
        </div>

      </div>
    </div>
  );
}
